<div class="detail-page tuote-katsele">
  <app-asiakas-otsikko otsikko="Tuote" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <div class="toiminnot-yla">
    <app-secondary-button (click)="takaisin()" actionId="Palaa tuoteselauslistaan">Takaisin listaan</app-secondary-button>
  </div>

  @if (tuoteObservable | async; as tuote) {
    <div class="tiedot-grid">
      <div class="kentta">
        <div class="otsikko">Ulkoinen tunniste</div>
        <div class="arvo mono">{{ tuote.ulkoinenTunniste || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Avain</div>
        <div class="arvo mono">{{ tuote.$key }}</div>
      </div>
      <div class="kentta laaja">
        <div class="otsikko">Nimi</div>
        <div class="arvo">{{ tuote.nimi }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Hinta</div>
        <div class="arvo num">{{ tuote.hinta | number: '1.2-2' : 'fi-FI' }} €</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Yksikkö</div>
        <div class="arvo">{{ tuote.yksikko || '–' }}</div>
      </div>
      <div class="kentta laaja">
        <div class="otsikko">Kuvaus</div>
        <div class="arvo">{{ tuote.kuvaus || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Lisätty</div>
        <div class="arvo">{{ tuote.date?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Poistettu</div>
        <div class="arvo">{{ tuote.poistettu ? 'Kyllä' : 'Ei' }}</div>
      </div>

      @if (tuote.alv && (tuote.alv | keyvalue).length > 0) {
        <div class="kentta laaja">
          <div class="otsikko">ALV-tunnisteet laskutyypeittäin</div>
          <table class="alv-taulu">
            <thead>
              <tr>
                <th>Laskutyyppi</th>
                <th>ALV-tunniste</th>
              </tr>
            </thead>
            <tbody>
              @for (alv of tuote.alv | keyvalue; track alv.key) {
                <tr>
                  <td class="mono">{{ alv.key }}</td>
                  <td class="mono">{{ alv.value }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  } @else {
    <div class="tyhja-tila">Tuotetta ei löytynyt.</div>
  }
</div>
